import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/Home.vue";
import { isSessionValid } from "../config.js"; 


const routes = [
  {
    path: "/",
    meta: {
      titleKey: "common.home",
      title: "HOME",
    },
    name: "Home",
    component: HomeView,
  },
 
   {
    path: "/change-password",
    meta: {
      titleKey: "auth.changePassword",
      title: "CHANGE PASSWORD ",
    },
    component: () => import("../views/ChangePasswordView.vue"),
  },
  //ROTAS COM ACESSO RESTRITO
 
  {
    path: "/resultadoshistopatologico",
    meta: {
      titleKey: "nav.histopathologyResults",
      title: "Interpretação de Análise Histopatológico  ",
    },
    component: () => import("../views/ResultadosHistopatologicoView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/resultadosPSA",
    meta: {
      titleKey: "nav.psaResults",
      title: "Interpretação do PSA  ",
    },
    component: () => import("../views/PSADiagnosticoView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/diagtoqueretal",
    meta: {
      titleKey: "nav.rectalResults",
      title: "Interpretação de Toque Retal  ",
    },
    component: () => import("../views/DiagnosticoTRView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/fixacao",
    meta: {
      titleKey: "nav.fixation",
      title: "FIXAÇÃ0",
    },
    component: () => import("../views/FixacaoView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },

  {
    path: "/examemacroscopica",
    meta: {
      titleKey: "nav.macroscopic",
      title: "EXAME MACROSCÓPICA",
    },
    component: () => import("../views/ExameMacroscopicaView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/desidratacao",
    meta: {
      titleKey: "nav.dehydration",
      title: "DESITDRATAÇÃO",
    },
    component: () => import("../views/DesidratacaoView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/inclusao",
    meta: {
      titleKey: "nav.embedding",
      title: "INCLUSÃO",
    },
    component: () => import("../views/InclusaoView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/cortes",
    meta: {
      titleKey: "nav.sections",
      title: "CORTES/ Micrótomo",
    },
    component: () => import("../views/CortesView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/h&e",
    meta: {
      titleKey: "nav.he",
      title: "Hematoxilina e Eosina",
    },
    component: () => import("../views/HeEView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/ihq",
    meta: {
      titleKey: "nav.ihc",
      title: "IMUNOHISTOQUÍMICA",
    },
    component: () => import("../views/IHQView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
   {
    path: "/montagem",
    meta: {
      titleKey: "nav.mounting",
      title: "MONTAGEM",
    },
    component: () => import("../views/MontagemView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/microscopica",
    meta: {
      titleKey: "nav.microscopy",
      title: "Análise Microscópica",
    },
    component: () => import("../views/AnaliseMicroscopicaView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },

  {
    path: "/lab3d",
    meta: {
      titleKey: "nav.lab3d",
      title: "LAB 3D",
    },
    component: () => import("../views/Lab3dView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/salavirtual",
    meta: {
      titleKey: "nav.classroom",
      title: "SALA DE AULA VIRTUAL",
    },
    component: () => import("../views/SaladeAulaView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/salavirtualfitsi",
    meta: {
      titleKey: "nav.jitsi",
      title: "SALA DE FITSI",
    },
    component: () => import("../views/SaladeAulaJitsiView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/resultadosh&e",
    meta: {
      titleKey: "nav.heResults",
      title: "DIAGNÓSTICOS H&E",
    },
    component: () => import("../views/DiagnosticosHeEView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
  {
    path: "/resultadosihq",
    meta: {
      titleKey: "nav.ihcResults",
      title: "DIAGNÓSTICOS IHQ",
    },
    component: () => import("../views/DiagnosticosIHQView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },
   {
    path: "/guidelines",
    meta: {
      titleKey: "nav.guidelines",
      title: "GUIDELINES CLÍNICOS",
    },
    component: () => import("../views/GuidelinesView.vue"),
    beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next("/"); // redireciona para home se não estiver logado
    },
  },

  //sem restricao

  
  {
    path: "/eventview/:id",
    meta: {
      titleKey: "nav.events",
      title: "EVENTOS",
    },
    name: "eventview",
    component: () => import("../views/EventView.vue"),
  },
   
  {
    path: "/noticias",
    meta: {
      titleKey: "nav.news",
      title: "NOTÍCIAS",
    },
    name: "NoticiasView",
    component: () => import("../views/NoticiasView.vue"),
  },
  {
    path: "/eventos",
    meta: {
      titleKey: "nav.events",
      title: "EVENTOS",
    },
    name: "EventosView",
    component: () => import("../views/EventosView.vue"),
  },
  {
    path: "/galerias",
    meta: {
      titleKey: "nav.galleries",
      title: "GALERIAS",
    },
    name: "GaleriaView",
    component: () => import("../views/GaleriaView.vue"),
  },
  {
    path: "/videos",
    meta: {
      titleKey: "nav.videos",
      title: "VIDEOS ",
    },
    name: "VideosView",
    component: () => import("../views/VideosView.vue"),
  },
  {
    path: "/forum",
    meta: {
      titleKey: "nav.forum",
      title: "FORÚM ",
    },
    name: "ForumView",
    component: () => import("../views/ForumView.vue"),
  },
  {
    path: "/repositorio",
    meta: {
      titleKey: "nav.repository",
      title: "REPOSIT]ORIO CIENTÍFICO ",
    },
    name: "RepositorioView",
    component: () => import("../views/RepositorioView.vue"),
  },

  {
    path: "/equipa",
    meta: {
      titleKey: "nav.team",
      title: "EQUIPA",
    },
    name: "EquipaView",
    component: () => import("../views/EquipaView.vue"),
  },

  {
    path: "/projeto",
    meta: {
      titleKey: "nav.project",
      title: "PROJETO",
    },
    name: "ProjetoView",
    component: () => import("../views/ProjetoView.vue"),
  },

  {
    path: "/saudemasculina",
    meta: {
      titleKey: "nav.mensHealth",
      title: "SAÚDE MASCULINA",
    },
    name: "SaudeMasculinaView",
    component: () => import("../views/SaudeMasculinaView.vue"),
  },
  {
    path: "/cancro",
    meta: {
      titleKey: "nav.cancer",
      title: "CANCRO ",
    },
    name: "CancroView",
    component: () => import("../views/CancroView.vue"),
  },
   {
    path: "/tratamentocancro",
    meta: {
      titleKey: "nav.cancerTreatment",
      title: "TRATAMENTO CANCRO ",
    },
    name: "TratamentoCancro",
    component: () => import("../views/TratamentoCancroView.vue"),
  },
  {
    path: "/hiperplazia",
    meta: {
      titleKey: "nav.hyperplasia",
      title: "HIPERPLAZIA ",
    },
    name: "HiperplaziaView",
    component: () => import("../views/HiperplaziaView.vue"),
  },
  {
    path: "/prostatite",
    meta: {
      titleKey: "nav.prostatitis",
      title: "PROSTATITE ",
    },
    name: "ProstatiteView",
    component: () => import("../views/ProstatiteView.vue"),
  },
  {
    path: "/analisesclinicas",
    meta: {
      titleKey: "nav.clinicalAnalysis",
      title: "ANÁLISES CLÍNICAS ",
    },
    component: () => import("../views/AnalisesClinicasView.vue"),
  },

  {
    path: "/toqueretal",
    meta: {
      titleKey: "nav.rectalExam",
      title: "TOQUE RETAL ",
    },
    component: () => import("../views/ToqueRetalView.vue"),
  },
  {
    path: "/exameimagens",
    meta: {
      titleKey: "nav.imaging",
      title: "EXAME IMAGENS ",
    },
    component: () => import("../views/ExameImagensView.vue"),
  },
  {
    path: "/examesanguineo",
    meta: {
      titleKey: "nav.bloodTest",
      title: "EXAME SANGUINEO ",
    },
    component: () => import("../views/ExameSanguineoView.vue"),
  },
  {
    path: "/examehistopatologico",
    meta: {
      titleKey: "nav.histopathologyExam",
      title: "EXAME HISTOPATOLÓGICO ",
    },
    component: () => import("../views/ExameHistopatologicoView.vue"),
  },
  {
    path: "/examelipidomica",
    meta: {
      titleKey: "nav.lipidomics",
      title: "EXAME LIPIDÓMICA ",
    },
    component: () => import("../views/ExameLipidomicaView.vue"),
  },

  // outras rotas...
  /*beforeEnter: (to, from, next) => {
      if (isSessionValid()) next();
      else next('/'); // redireciona para home se não estiver logado
    },*/
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});


export default router;

